const STORAGE_KEY = 'omnichek_web_scan_device_id';

/**
 * Stable pseudonymous id for this browser profile (logged-in internal scans via HID wedge).
 */
export function getWebScanDeviceId() {
  try {
    let id = localStorage.getItem(STORAGE_KEY);
    if (!id) {
      id =
        typeof globalThis.crypto !== 'undefined' && globalThis.crypto.randomUUID
          ? `web:hid:${globalThis.crypto.randomUUID()}`
          : `web:hid:${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch {
    return 'web:hid:unknown';
  }
}
